/** include in bind :
 *
 *  this.animRounding = new animRounding({
			container: this.dom.containerImages,
			mask: this.dom.mask,
			inner: this.dom.images
		}, this.params.current, this._onComplete.bind(this));


	Add onComplete in your js :

	 _onComplete(indexCurrent) {
			this.params.current = indexCurrent;
			this.params.canClick = true;
		}
 */

import States from './states';

export default class animRounding {

	constructor(dom, indexCurrent, callback ) {
		this.callback = callback;

		this.dom = {};
		this.dom.container = dom.container;
		this.dom.mask = dom.mask;
		this.dom.inner = dom.inner;

		this.params = {};
		this.params.current = indexCurrent;

		this._isOldBrowser = ( ENV.browser == 'none' ) ? true : false; //disable variable to none
		this._isChrome = ( ENV.browser == 'chrome' ) ? false : false;
	}

	animate( indexNext, positionAnim = false, componentSize = false ) {

		this.animImages = new TimelineMax({
			onComplete: () => {
				this.dom.container[indexNext].style.zIndex = "3";
				this.params.current = indexNext;
				this.callback(this.params.current);
			}
		});


		/////////
		// Mask Animation

		let multiplicator = 2.25;
		let maskSize = {
			percent : 100 * multiplicator,
		};
		let maskPositionFrom = '102% center';
		let maskPositionTo = '90% center'

		if( positionAnim != false && componentSize != false ) {
			multiplicator = 3;
			maskSize = {
				percent : 100 * multiplicator,
				width_px : componentSize.width * multiplicator,
				height_px : componentSize.height * multiplicator,

			};

			let maskHalfSizePx_W = maskSize.width_px / 1.6;
			let maskHalfSizePx_H = maskSize.height_px / 1.6;

			maskPositionFrom = parseInt(positionAnim.left - componentSize.left) + "px " + parseInt(positionAnim.top - componentSize.top) + "px";
			maskPositionTo = parseInt(positionAnim.left - componentSize.left - maskHalfSizePx_W ) + "px " + parseInt(positionAnim.top - componentSize.top - maskHalfSizePx_H ) + "px";
		}

		const pos = {webkitMaskPosition: '-200% center', webkitMaskSize: "170%"}
		this.animImages.to(pos, 1, {webkitMaskPosition: '50% center', webkitMaskSize: "170%", ease:Linear.easeNone, onUpdate: (e) => {
			this.dom.mask[indexNext].style.webkitMaskPosition = e.target.webkitMaskPosition;
		}, onUpdateParams: ["{self}"]})


		this.animImages
			.to(
				this.dom.container[indexNext], 0,
				{
					autoAlpha: 1,
					zIndex: 15,
				}, 0)
			.to(
				this.dom.container[this.params.current], 0,
				{
					autoAlpha: 0,
					zIndex: 2
				})


		// this.animImages.to(this.dom.container[indexNext], 0, {
		// 	autoAlpha: 1,
		// 	zIndex: 15,
		// }, 0)
		// 	.fromTo(this.dom.mask[indexNext], 1.5, {//2
		// 		// webkitMaskPosition: '-200% center',
		// 		// webkitMaskSize: "170%",
		// 	},{
		// 		// webkitMaskPosition: '50% center',
		// 		// webkitMaskSize: "170%",
		// 		ease: Power3.easeNone,
		// 		onStart: () => {
		// 			this.animImages.fromTo(this.dom.inner[indexNext], 0.5, {
		// 				// scale: 1.3,
		// 				// rotation: 15,
		// 				// y:'-50%',
		// 				// x:'-50%'
		// 			},{
		// 				// transformOrigin: "-100px 110%",
		// 				// scale: 1,
		// 				// rotation: 0,
		// 				// y:'-50%',
		// 				// x:'-50%',
		// 				ease: Power1.easeOut,
		// 			}, 0)
		// 				.to(this.dom.container[this.params.current], 0, {
		// 					autoAlpha: 0,
		// 					zIndex: 2
		// 				})
		// 		}
		// 	});

		// this.animImages = new TimelineMax({
		//     onComplete: () => {
		//         this.dom.container[indexNext].style.zIndex = "3";
		//         this.params.current = indexNext;
		//         this.callback(this.params.current);
		//     }
		// });
		//
		// this.animImages.to(this.dom.container[indexNext], 0, {
		//     autoAlpha: 1,
		//     zIndex: 15,
		// }, 0)
		//     .fromTo(this.dom.mask[indexNext], 0.8, {
		//         webkitMaskPosition: "102% center",
		//         webkitMaskSize: "0%",
		//     },{
		//         webkitMaskPosition: "90% center",
		//         webkitMaskSize: "200%",
		//         ease: Power0.easeNone,
		//         onStart: () => {
		//             this.animImages.fromTo(this.dom.inner[indexNext], 0.5, {
		//                 rotation: 15,
		//                 y:'-50%',
		//                 x:'-50%',
		//                 scale: 1.3
		//             },{
		//                 transformOrigin: "-100px 110%",
		//                 scale: 1,
		//                 rotation: 0,
		//                 y:'-50%',
		//                 x:'-50%',
		//                 ease: Power1.easeOut,
		//             }, 0)
		//                 .to(this.dom.container[this.params.current], 0, {
		//                     autoAlpha: 0,
		//                     zIndex: 2
		//                 })
		//         }
		//     });
	}

	animate_homepage( indexNext, positionAnim, operator ) {

		this.animImages = new TimelineMax({
			onComplete: () => {
				this.dom.container[indexNext].style.zIndex = "3";
				this.params.current = indexNext;
				this.callback(this.params.current);
			}
		});

		this.animImages
			.to(this.dom.container[indexNext], 0,
				{autoAlpha: 1, zIndex: 15},
				0
			);

		if (this._isOldBrowser == false) {

			if( this._isChrome ) {
				// ClipPath Animation
				this.animImages
					.fromTo(
						this.dom.mask[indexNext], 1,
						// this.dom.mask[indexNext], 1.5,
						// {  },
						{ webkitClipPath: 'circle(0px at ' + positionAnim.left + 'px ' + positionAnim.top + 'px)', clipPath: 'circle(0px at ' + positionAnim.left + 'px ' + positionAnim.top + 'px)' },
						{
							webkitClipPath: 'circle(' + (States.width * 1.5) + 'px at ' + positionAnim.left + 'px ' + positionAnim.top + 'px)', clipPath: 'circle(0px at ' + positionAnim.left + 'px ' + positionAnim.top + 'px)',
							// webkitClipPath: 'circle(' + (States.width * 2) + 'px at ' + positionAnim.left + 'px ' + positionAnim.top + 'px)', clipPath: 'circle(0px at ' + positionAnim.left + 'px ' + positionAnim.top + 'px)',
							// ease: Back.easeOut.config(1),
							onStart: this._onStartAnim.bind(this, indexNext, operator)
						}
					);

			} else {
				// Mask Animation
				let ratio = ( States.width > States.height ) ? 1 : States.height / States.width;
				let multiplicator = 3; // 2.2
				let maskSize = {
					px : States.width * ratio * multiplicator, // 100 * multiplicator,
					percent : 100 * ratio * multiplicator, // States.width * multiplicator
				};
				let maskHalfSizePx = maskSize.px / 2;

				// console.log('from', positionAnim.left, positionAnim.top, maskSize.percent);
				// console.log('to', positionAnim.left, maskHalfSizePx,  (positionAnim.left - maskHalfSizePx))

				const pos = {webkitMaskPosition: positionAnim.left + "px " + positionAnim.top + "px", webkitMaskSize: "0%"};
				this.animImages.to(pos, 0.4, {webkitMaskPosition: (positionAnim.left - maskHalfSizePx) + "px " + (positionAnim.top - maskHalfSizePx) + "px", webkitMaskSize: maskSize.percent + "%", ease: Linear.easeNone, onStart: this._onStartAnim.bind(this, indexNext, operator), onUpdate: (e) => {
					this.dom.mask[indexNext].style.webkitMaskPosition = e.target.webkitMaskPosition;
					this.dom.mask[indexNext].style.webkitMaskSize = e.target.webkitMaskSize;
				}, onUpdateParams: ["{self}"]});
			}

		} else {
			// Opacity Animation
			this.animImages
				.fromTo(
					this.dom.mask[indexNext], 1.5,
					{ autoAlpha : 0 },
					{
						autoAlpha : 1,
						ease: Back.easeOut.config(1),
						onStart: this._onStartAnim.bind(this, indexNext)
					}
				);
		}
	}

	_onStartAnim( indexNext, operator ) {

		this.animImages
			.fromTo(
				this.dom.inner[ indexNext ], 1,
				{
					// rotation: 0,
					// scale: 1,
					scale: 1,
					// scale: 1.1,
					// scale: 1.2
					// rotation: 9 * operator,
					transformStyle: "preserve-3d",
					transformPerspective: 1000,
					force3D: true,
					// rotation: 9 * operator,
					y:'-50%',
					x:'-50%',
				},
				{
					// transformOrigin: "50% 50%",
					scale: 1,
					// rotation: 0,
					transformStyle: "preserve-3d",
					transformPerspective: 1000,
					y:'-50%',
					x:'-50%',
					// delay: 0.9,
					force3D: true,
					ease: Power1.easeOut,
				},
				0.1
			)
			.to( this.dom.container[this.params.current], 0,
				{
					autoAlpha: 0,
					zIndex: 2
				}
			);
	}

}

/**

 **/



// WEBPACK FOOTER //
// src/js/helpers/anim-rounding.js